import env from '../env'
import jwt_decode from 'jwt-decode'
import { termsAcceptance } from '../api/user'
import { notifyError } from './logger'

/**
 * This function obtains the user object from localstorage.
 *
 * @returns object
 */
export const getAuthUser = () => {
  let user

  try {
    user = JSON.parse(localStorage.getItem('user'))
  } catch (e) {
    notifyError(e)
    user = null
  }

  return user
}

export const setAuthUserAvatar = avatar => {
  const user = getAuthUser()
  user.avatar = avatar
  localStorage.setItem('user', JSON.stringify(user))
}

/**
 * This function obtains the user token from localstorage.
 *
 * @returns string
 */
export const getAuthToken = () => {
  let token
  try {
    token = localStorage.getItem('token')
  } catch (err) {
    notifyError(err)
    throw new Error(err.message)
  }

  return token
}

/**
 * This function returns the user capability level.
 *
 * @returns string
 */
export const getAuthUserCapabilities = () => {
  const user = getAuthUser()
  return user ? user[`wp_${env.wpSiteId}_user_level`] : null
}

export const isUserActive = (user = null) => {
  if (!user) {
    user = getAuthUser()
  }

  return user.user_meta ?? !!user[`wp_${env.wpSiteId}_user_level`]
}

/**
 * This function checks if the user is admin in Miib.
 *
 * @returns boolean
 */
export const authIsAdmin = () => {
  const ADMIN_LEVEL = 10
  return parseInt(getAuthUserCapabilities()) === ADMIN_LEVEL
}

/**
 * This function checks the jwt validity
 *
 */
export const tokenIsValid = (token = null, user = null) => {
  const SECOND_IN_MS = 1000
  token = token || getAuthToken()

  if (!token) return false

  const { exp, sub } = jwt_decode(token)
  const now = Date.now() / SECOND_IN_MS
  const isExpired = exp < now
  const userId = user ? user.ID : getAuthUser().ID
  const isAuthUser = parseInt(sub) === parseInt(userId)

  return !isExpired && isAuthUser
}

/**
 * This function sets if the user has accepted the terms of service.
 *
 * @param int user_id
 * @returns void
 */
export const setTermsAcceptanceStatus = async user_id => {
  let accepted = false
  try {
    const { data } = await termsAcceptance(user_id)
    accepted = !!data.length
  } catch (error) {
    notifyError(error)
    console.error(error)
  }

  localStorage.setItem('termsAccepted', accepted)
}

/**
 * This function checks if the user has accepted the terms of service.
 * First checks if there any value in local storage, then fetches the api.
 * @returns boolean
 */
export const checkLocalTermsAcceptanceStatus = async () => {
  if (localStorage.getItem('termsAccepted') === null) {
    await setTermsAcceptanceStatus(getAuthUser().ID)
  }

  return localStorage.getItem('termsAccepted') === 'true'
}

export const logout = () => {
  localStorage.removeItem('token')
  localStorage.removeItem('user')
  localStorage.removeItem('termsAccepted')
  localStorage.removeItem('userList')
  disableContextMenu()
}

export const disableContextMenu = (isAdmin = false) => {
  document.oncontextmenu = () => (isAdmin ? true : false)
}
